import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PrevArrowIcon = ({ onClick })=>/*#__PURE__*/ _jsxs("svg", {
        onClick: onClick,
        width: "57",
        height: "57",
        viewBox: "0 0 57 57",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "28.5",
                cy: "28.5",
                r: "28",
                fill: "white",
                stroke: "#DCDFEC"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.7929 29.2071C14.4024 28.8166 14.4024 28.1834 14.7929 27.7929L21.1569 21.4289C21.5474 21.0384 22.1805 21.0384 22.5711 21.4289C22.9616 21.8195 22.9616 22.4526 22.5711 22.8431L16.9142 28.5L22.5711 34.1569C22.9616 34.5474 22.9616 35.1805 22.5711 35.5711C22.1805 35.9616 21.5474 35.9616 21.1569 35.5711L14.7929 29.2071ZM41.5 29.5H15.5V27.5H41.5V29.5Z",
                fill: "black"
            })
        ]
    });
